/* OO(2026-10-08) スマホで買い物しやすくする直し */
(function () {
  'use strict';

  /* ★この表は **OLD ORDER の表** です。Ocai / BBiMP は cm が違います（下の説明）。 */
  var CM = {
    '35': '23.0', '36': '23.5', '37': '24.0', '38': '24.5', '39': '25.0',
    '40': '25.5', '41': '26.0', '42': '26.5', '43': '27.0', '44': '27.5',
    '45': '28.0', '46': '28.5', '47': '29.0'
  };

  function sizeOf(label) {
    if (!label) return null;
    var made = label.querySelector('.oo-size-eu');
    if (made) return made.textContent.trim();
    var m = (label.textContent || '').trim().match(/(^|\s)(\d{2})(\s|$)/);
    return m ? m[2] : null;
  }

  function labelOf(input) {
    if (!input) return null;
    if (input.id) {
      var byFor = document.querySelector('label[for="' + input.id + '"]');
      if (byFor) return byFor;
    }
    return input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL'
      ? input.nextElementSibling
      : null;
  }

  /* ================================================================
     ★大事なこと：cm の表はブランドごとに違います（2026-10-11 判明）

     商品説明のサイズ表を調べたところ、3つのブランドで違っていました。
       EU35 → OLD ORDER 23.0cm ／ Ocai 22.5cm ／ BBiMP 22.5cm
       EU47 → BBiMP 30.5cm（上の CM の表だと 29.0cm。1.5cm も違う）
     上の CM の表は OLD ORDER の表で、OLD ORDER の商品説明とは一致しますが、
     Ocai と BBiMP では間違った cm を出していたことになります。
     サイズ交換をお受けしていないので、間違った cm はそのまま誤注文につながります。

     そこで、正しい表がはっきりするまでは OLD ORDER の商品だけ cm を出します。
     Ocai と BBiMP は数字（35〜47）だけを出し、cm は商品説明の表を見ていただきます。
     ★メーカー表が確かめられたら、ブランドごとの表を足してください。
     ================================================================ */
  function ooBrand() {
    var t = (document.querySelector('h1.product__title, h1') || {}).textContent || '';
    if (/OLD\s*ORDER/i.test(t)) return 'oldorder';
    if (/Ocai/i.test(t)) return 'ocai';
    if (/BBIMP/i.test(t)) return 'bbimp';
    return 'other';
  }

  /* サイズのボタンに cm を添える（OLD ORDER のときだけ） */
  function addCm() {
    var useCm = ooBrand() === 'oldorder';
    document.querySelectorAll('.product__variant-picker .product-option__label').forEach(function (label) {
      if (label.getAttribute('data-oo-cm')) return;
      var raw = (label.textContent || '').trim().match(/(^|\s)(\d{2})(\s|$)/);
      var eu = raw ? raw[2] : null;
      if (!eu || !CM[eu]) return;

      var hidden = label.querySelector('.visually-hidden');
      var num = document.createElement('span');
      num.className = 'oo-size-eu';
      num.textContent = eu;

      label.textContent = '';
      label.appendChild(num);
      if (useCm) {
        var cm = document.createElement('span');
        cm.className = 'oo-size-cm';
        cm.textContent = CM[eu] + 'cm';
        label.appendChild(cm);
      }
      if (hidden) label.appendChild(hidden);
      label.setAttribute('data-oo-cm', '1');   // cm を出さないときも印は付ける
    });
  }

  /* サイズの見出しの下に「選び方」を1行 */
  function addGuide() {
    var picker = document.querySelector('.product__variant-picker');
    if (!picker || picker.querySelector('.oo-size-guide')) return;
    var label = picker.querySelector('.form__label');
    if (!label) return;
    var p = document.createElement('p');
    p.className = 'oo-size-guide';
    //   ★「26.5cm＝42」は OLD ORDER の表での話。ほかのブランドは cm の基準が違うので出さない。
    p.innerHTML = (ooBrand() === 'oldorder'
      ? 'ふだん <b>26.5cm</b> の方は <b>42</b>。甲高・幅広や厚手の靴下なら <b>0.5cm 上</b>。'
      : 'cm の目安は下の商品説明をご覧ください。')
      + '<span class="oo-size-warn">サイズ交換はお受けできません</span>';
    label.insertAdjacentElement('afterend', p);
  }

  /* 下に付いてくる「カートに追加」 */
  var bar = null;
  function buildBar() {
    if (bar || !document.querySelector('.product-form__submit')) return;
    bar = document.createElement('div');
    bar.className = 'oo-buybar';
    bar.innerHTML =
      '<span class="oo-buybar__info">' +
      '<span class="oo-buybar__size"></span>' +
      '<span class="oo-buybar__price"></span>' +
      '</span>' +
      '<button type="button" class="oo-buybar__btn">カートに追加</button>';
    document.body.appendChild(bar);
    bar.querySelector('.oo-buybar__btn').addEventListener('click', function () {
      var real = document.querySelector('.product-form__submit');
      if (real) real.click();
    });
  }

  function updateBar() {
    if (!bar) return;
    var real = document.querySelector('.product-form__submit');
    if (!real) return;
    var picker = document.querySelector('.product__variant-picker');
    var checked = picker ? picker.querySelector('input:checked') : null;
    var eu = sizeOf(labelOf(checked));
    var useCm = ooBrand() === 'oldorder';

    bar.querySelector('.oo-buybar__size').textContent =
      (ooSizePicked && eu)
        ? 'サイズ ' + eu + ((useCm && CM[eu]) ? '（' + CM[eu] + 'cm）' : '')
        : 'サイズをお選びください';

    var priceEl = document.querySelector('.product__price');
    var m = priceEl ? (priceEl.textContent || '').match(/[¥￥][\d,]+/) : null;
    bar.querySelector('.oo-buybar__price').textContent = m ? m[0] : '';

    var btn = bar.querySelector('.oo-buybar__btn');
    btn.textContent = ooSizePicked
      ? ((real.textContent || '').replace(/\s+/g, ' ').trim() || 'カートに追加')
      : 'サイズを選ぶ';
    btn.disabled = !!real.disabled;

    var r = real.getBoundingClientRect();
    var realVisible = r.top < window.innerHeight && r.bottom > 0;
    var on = !realVisible && window.innerWidth < 750;
    bar.classList.toggle('is-on', on);
    document.body.classList.toggle('oo-buybar-on', on);
  }

  /* レビューが0件なら枠ごと隠す */
  function hideEmptyReview() {
    var stats = document.querySelector('.LeeepReviewStatsSummary, .LeeepReviewStats');
    if (!stats) return;
    if (/(^|\D)0\s*人のレビュー/.test(stats.textContent || '')) {
      document.body.classList.add('oo-no-review');
    }
  }

  /* メニューのいちばん上に「NEW（新作）」を足す */
  function addNewLink() {
    document.querySelectorAll('.primary-menu-panel > ul').forEach(function (list) {
      if (list.querySelector('[data-oo-new]')) return;
      if (!list.firstElementChild) return;
      var li = document.createElement('li');
      li.innerHTML = '<a class="menu-link h4" data-oo-new href="/collections/new-arrived-1">NEW（新作）</a>';
      list.insertBefore(li, list.firstElementChild);
    });

    document.querySelectorAll('ul.header__nav-items').forEach(function (list) {
      if (list.querySelector('[data-oo-new]')) return;
      if (!list.firstElementChild) return;
      var li = document.createElement('li');
      li.className = 'header__nav-item js-nav-item';
      li.innerHTML =
        '<a class="header__nav-link js-nav-link text--link" data-oo-new' +
        ' href="/collections/new-arrived-1">NEW（新作）</a>';
      list.insertBefore(li, list.firstElementChild);
    });
  }

  /* 一覧ページの件数（中身を触ると facets.js が止まるので ::after で出す） */
  function fixShowing() {
    var all = Array.prototype.slice.call(document.querySelectorAll('div, p, span, small'));
    var cand = all.filter(function (e) {
      var t = (e.textContent || '').replace(/\s+/g, ' ');
      return t.length < 60 && /Showing\s*\d+\s*of\s*\d+/i.test(t);
    });
    if (!cand.length) return;
    var box = cand[cand.length - 1];
    var m = (box.textContent || '').replace(/\s+/g, ' ').match(/Showing\s*(\d+)\s*of\s*(\d+)/i);
    if (!m) return;

    if (!box.getAttribute('data-oo-fs')) {
      box.setAttribute('data-oo-fs', window.getComputedStyle(box).fontSize || '1.3rem');
    }

    var filtered = window.location.search.indexOf('filter.') >= 0;
    var label = (filtered ? m[1] : m[2]) + '点';

    box.style.setProperty('--oo-count', '"' + label + '"');
    box.style.setProperty('--oo-count-size', box.getAttribute('data-oo-fs'));
    box.classList.add('oo-count-ja');
  }

  window.ooFixShowing = fixShowing;

  function fixShortWords() {
    var pairs = [
      ['OOPS!', 'ページが見つかりません'],
      ['NO PRODUCTS IN THIS COLLECTION', 'この一覧には、今のところ商品がありません']
    ];
    Array.prototype.slice.call(document.querySelectorAll('h1, h2, h3, p, span, div')).forEach(function (e) {
      if (e.children.length) return;
      var t = (e.textContent || '').trim();
      for (var i = 0; i < pairs.length; i += 1) {
        if (t.toUpperCase() === pairs[i][0]) {
          e.textContent = pairs[i][1];
          return;
        }
      }
    });
  }

  /* 商品ページの「数量」まわりに残っていた英語を日本語に */
  function fixQuantityWords() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var raw = node.nodeValue || '';
      if (raw.indexOf('in cart') < 0 && !/quantity for /i.test(raw)) continue;
      var fixed = raw
        .replace(/(\d+)\s*in\s*cart/gi, function (all, num) {
          return 'カートに' + num + '点';
        })
        .replace(/Decrease quantity for\s*/i, '数量を1つ減らす ')
        .replace(/Increase quantity for\s*/i, '数量を1つ増やす ');
      if (fixed !== raw) node.nodeValue = fixed;
    }
  }

  /* ================================================================
     OODAY（会員様限定 全商品10%OFF）のお知らせ・2026-10-11 会長
     日本時間 2026-10-12 23:59 を過ぎたら、帯の文も含めて自動で消えます。
     ================================================================ */
  var OODAY_END = new Date('2026-10-12T23:59:59+09:00').getTime();
  var OODAY_TEXT = 'OODAY｜10/12(月・祝)まで 会員様限定 全商品10%OFF';
  var OODAY_NOTE = 'OODAY｜10/12(月・祝)まで 会員様は10%OFF（ログインしてご利用ください）';

  function oodayToday() {
    return new Date(Date.now() + 9 * 3600 * 1000).toISOString().slice(0, 10);
  }

  function oodayClosedToday() {
    try { return localStorage.getItem('oo_ooday_closed') === oodayToday(); } catch (e) { return false; }
  }

  function oodayHideBar() {
    document.querySelectorAll('.announcement-bar .marquee__item').forEach(function (li) {
      if (/OODAY/.test(li.textContent || '')) li.style.setProperty('display', 'none', 'important');
    });
  }

  function oodayNote() {
    if (document.querySelector('.oo-ooday-note')) return;
    var price = document.querySelector('.product__price');
    if (!price) return;
    var p = document.createElement('p');
    p.className = 'oo-ooday-note';
    p.textContent = OODAY_NOTE;
    price.insertAdjacentElement('afterend', p);
  }

  function oodayPopup() {
    if (oodayClosedToday()) return;
    if (document.querySelector('.oo-ooday')) return;
    var box = document.createElement('div');
    box.className = 'oo-ooday';
    box.innerHTML =
      '<div class="oo-ooday__back"></div>' +
      '<div class="oo-ooday__card" role="dialog" aria-modal="true" aria-label="OODAY のお知らせ">' +
      '<button type="button" class="oo-ooday__x" aria-label="閉じる">&times;</button>' +
      '<p class="oo-ooday__text"></p>' +
      '<a class="oo-ooday__go" href="/account/login">ログインする</a>' +
      '<button type="button" class="oo-ooday__close">閉じる</button>' +
      '</div>';
    box.querySelector('.oo-ooday__text').textContent = OODAY_TEXT;
    document.body.appendChild(box);

    function close() {
      if (box.parentNode) box.parentNode.removeChild(box);
      try { localStorage.setItem('oo_ooday_closed', oodayToday()); } catch (e) {}
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    box.querySelector('.oo-ooday__x').addEventListener('click', close);
    box.querySelector('.oo-ooday__close').addEventListener('click', close);
    box.querySelector('.oo-ooday__back').addEventListener('click', close);
    document.addEventListener('keydown', onKey);
  }

  function ooday(first) {
    if (Date.now() > OODAY_END) { oodayHideBar(); return; }
    oodayNote();
    if (first) oodayPopup();
  }

  /* ================================================================
     サイズを選ぶ前に買えてしまうのを防ぐ（2026-10-11 確認役の指摘・最優先）

     Shopify は商品ページを開いた時点で「いちばん小さいサイズ」を選んだ状態にします。
     そのため、サイズを一度も押さなくても「カートに追加」で 35 が入ってしまっていました。
     サイズ交換をお受けしていないので、誤注文は実害が大きいところです。
     Shopify 側の選択状態はいじらず、「自分で押したか」だけを覚えています。
     ================================================================ */
  var ooSizePicked = false;

  function ooSizeApply() {
    document.body.classList.toggle('oo-need-size', !ooSizePicked);
    document.querySelectorAll('.product-form__submit').forEach(function (b) {
      b.classList.toggle('oo-need-size', !ooSizePicked);
    });
  }

  function ooSizePick() {
    if (ooSizePicked) return;
    ooSizePicked = true;
    ooSizeApply();
    updateBar();
  }

  //   cm を出さないブランド（Ocai / BBiMP）もあるので、cm ではなく data-oo-cm の印で見る
  function ooIsSizeLabel(el) {
    var lb = el && el.closest ? el.closest('.product-option__label') : null;
    return !!(lb && lb.getAttribute('data-oo-cm'));
  }

  function ooSizeGuard() {
    var picker = document.querySelector('.product__variant-picker');
    if (!picker) return;
    if (location.search.indexOf('variant=') >= 0) ooSizePicked = true;
    ooSizeApply();

    //   ★売り切れのサイズを押しても Shopify は選ばないので、
    //     「押した札が本当に選ばれたか」を見てから「選んだ」とします。
    document.addEventListener('click', function (e) {
      var lb = e.target.closest ? e.target.closest('.product-option__label') : null;
      if (!lb || !lb.getAttribute('data-oo-cm')) return;
      var id = lb.getAttribute('for');
      setTimeout(function () {
        var inp = id ? document.getElementById(id) : null;
        if (inp && inp.checked) ooSizePick();
      }, 350);
    }, true);
    document.addEventListener('change', function (e) {
      var p = document.querySelector('.product__variant-picker');
      if (!p || !p.contains(e.target)) return;
      if (ooIsSizeLabel(labelOf(e.target))) ooSizePick();
    }, true);

    // まだ選んでいないのに買おうとしたら、止めてサイズの欄へ
    document.addEventListener('click', function (e) {
      if (ooSizePicked) return;
      if (!e.target.closest) return;
      var t = e.target.closest('.product-form__submit, .oo-buybar__btn, .shopify-payment-button');
      if (!t) return;
      e.preventDefault();
      e.stopPropagation();
      var p = document.querySelector('.product__variant-picker');
      if (!p) return;
      p.scrollIntoView({ behavior: 'smooth', block: 'center' });
      p.classList.add('oo-size-flash');
      setTimeout(function () { p.classList.remove('oo-size-flash'); }, 1300);
    }, true);
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    addCm();
    addGuide();
    hideEmptyReview();
    addNewLink();
    fixShowing();
    fixShortWords();
    fixQuantityWords();
    ooday(true);
    buildBar();
    ooSizeGuard();
    updateBar();

    window.addEventListener('scroll', updateBar, { passive: true });
    window.addEventListener('resize', updateBar);
    document.addEventListener('change', function () {
      setTimeout(function () { addCm(); updateBar(); }, 50);
    }, true);

    var tries = 0;
    var timer = setInterval(function () {
      addCm();
      hideEmptyReview();
      addNewLink();
      fixShowing();
      fixShortWords();
      fixQuantityWords();
      ooday(false);
      buildBar();
      ooSizeApply();
      updateBar();
      tries += 1;
      if (tries >= 12) clearInterval(timer);
    }, 600);
  });
})();
